import React from 'react';
import {
  Col,
  Row,
  Carousel,
} from 'antd';
import { useSelector } from 'react-redux';
import { selectCarousels } from 'store/app';
import { COLORS, Img } from 'components';
import styled from 'styled-components';
import { CaretLeftOutlined, CaretRightOutlined } from '@ant-design/icons';

// eslint-disable-next-line react/prop-types
const A = ({ href, children }) => (href ? <a href={href}>{children}</a> : children);
const columnsById = { 1: 15, 2: 9 };

const Carousels = () => {
  const carousels = useSelector(selectCarousels);
  if (!carousels.length) return null;

  return (
    <Container gutter={[15, 15]} style={{ paddingLeft: 10, marginBottom: 20 }}>
      {carousels.map((carousel) => (
        <Col
          xs={24}
          sm={24}
          md={carousel.vertical ? (carousel.columnas || columnsById[carousel.id]) : 24}
          key={carousel.id}
        >
          <Carousel
            arrows
            prevArrow={<CaretLeftOutlined />}
            nextArrow={<CaretRightOutlined />}
            effect={carousel.tipo_de_movimiento === 3 ? 'fade' : 'scrollx'}
            autoplay={[2, 3].includes(carousel.tipo_de_movimiento)}
            speed={carousel.tipo_de_movimiento === 3 ? 2000 : 1000}
            autoplaySpeed={5000}
            pauseOnDotsHover
            pauseOnFocus
            pauseOnHover
          >
            {carousel.imagenes.map((imagen) => (
              <div key={imagen.id} style={{ overflow: 'hidden' }}>
                <A href={imagen.liga_relacionada}>
                  <Img
                    src={imagen.base64 || imagen.archivo}
                    style={{
                      height: carousel.vertical ? '70vh' : '45vh',
                      width: '100%',
                    }}
                    alt={imagen.descripcion}
                  />
                </A>
              </div>
            ))}
          </Carousel>
        </Col>
      ))}
    </Container>
  );
};

const Container = styled(Row)`
.ant-carousel .slick-dots {
  &.slick-dots-bottom {
    margin-top: 20px;
  }
  li button {
    background: ${COLORS.accent};
    height: 6px;
    border-radius: 3px;
    border: 1px solid #FFF;
  }
}

.ant-carousel .slick-prev, .ant-carousel .slick-next {
  font-size: 26px;
  color: ${COLORS.accent};
  opacity: 0.4;
}

.ant-carousel .slick-prev:hover, .ant-carousel .slick-next:hover {
  opacity: 1;
}

.ant-carousel .slick-prev, .ant-carousel .slick-prev:hover {
  left: 20px;
  z-index: 2;
}

.ant-carousel .slick-next, .ant-carousel .slick-next:hover {
  right: 20px;
  z-index: 2;
}
`;

export default Carousels;
